<script setup lang="ts">
import type { ChecklistStatus } from '@ck/domain'
defineProps<{ status: ChecklistStatus; compact?: boolean }>()
const labels: Record<ChecklistStatus, string> = { pending: 'Pendente', ok: 'OK', attention: 'Atenção', rejected: 'Reprovado', notApplicable: 'N/A' }
</script>

<template><span class="status" :class="[`status--${status}`, { compact }]">{{ labels[status] }}</span></template>

<style scoped>
.status { display: inline-flex; align-items: center; padding: 5px 11px; border-radius: var(--radius-full); font-size: var(--fs-xs); font-weight: var(--fw-bold); }
.compact { padding: 3px 8px; }
.status--pending,.status--notApplicable { color: var(--ck-info-text); background: var(--ck-info-bg); }
.status--ok { color: var(--ck-ok-text); background: var(--ck-ok-bg); }
.status--attention { color: var(--ck-warn-text); background: var(--ck-warn-bg); }
.status--rejected { color: var(--ck-fail-text); background: var(--ck-fail-bg); }
</style>

